export { default as BgImageTemplate} from "./BgImageTemplate";
export { default as SideImageTemplate} from "./SideImageTemplate";
export { default as NoImageTemplate} from "./NoImageTemplate";
